<template>
  <div
    class="disp-modal pw-modal"
    id="pw-modal"
    v-modal-accessibility="{ isOpen: isOpenedProfileModal, onClose: toggleProfileModal }"
  >
    <div class="container">
      <div class="profile-modal-wrap">
        <div class="modal-overlay" @click="toggleProfileModal"></div>
        <div class="modal-content-wrap profile-modal-menu">
          <div class="profile-modal-info">
            <div>
              <p>{{ user?.name }}</p>
              <p style="color: #808080;">{{ user?.email }}</p>
            </div>
            <div class="profile-modal-info profile-plan">{{ currentActiveTariff?.name }}</div>
          </div>
          <router-link :to="{ name: 'profile-view' }" class="profile-modal-info_item profile">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                  d="M16 7C16 9.20914 14.2091 11 12 11C9.79086 11 8 9.20914 8 7C8 4.79086 9.79086 3 12 3C14.2091 3 16 4.79086 16 7Z"
                  stroke="#3749C0" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M12 14C8.13401 14 5 17.134 5 21H19C19 17.134 15.866 14 12 14Z" stroke="#3749C0"
                    stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <p>{{ $t('poperProfile') }}</p>
          </router-link>
          <router-link :to="{ name: 'team-view' }" class="profile-modal-info_item team">
            <svg
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
              <path
                  d="M18 21a8 8 0 0 0-16 0"
                  stroke="#3749C0"
                  stroke-width="1.3"
                  stroke-linecap="round"
                  stroke-linejoin="round"
              />
              <circle
                  cx="10"
                  cy="8"
                  r="5"
                  stroke="#3749C0"
                  stroke-width="1.3"
                  stroke-linecap="round"
                  stroke-linejoin="round"
              />
              <path
                  d="M22 20c0-3.37-2-6.5-4-8a5 5 0 0 0-.45-8.3"
                  stroke="#3749C0"
                  stroke-width="1.3"
                  stroke-linecap="round"
                  stroke-linejoin="round"
              />
            </svg>
            <p>{{ $t('poperTeam') }}</p>
          </router-link>
          <router-link :to="{ name: 'billing-view' }" class="profile-modal-info_item billings">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g id="icon/24px/user">
                <path id="Vector"
                      d="M14 3H2C1.73478 3 1.48043 3.10536 1.29289 3.29289C1.10536 3.48043 1 3.73478 1 4V12C1 12.2652 1.10536 12.5196 1.29289 12.7071C1.48043 12.8946 1.73478 13 2 13H14C14.2652 13 14.5196 12.8946 14.7071 12.7071C14.8946 12.5196 15 12.2652 15 12V4C15 3.73478 14.8946 3.48043 14.7071 3.29289C14.5196 3.10536 14.2652 3 14 3ZM14 4V5.5H2V4H14ZM14 12H2V6.5H14V12ZM13 10.5C13 10.6326 12.9473 10.7598 12.8536 10.8536C12.7598 10.9473 12.6326 11 12.5 11H10.5C10.3674 11 10.2402 10.9473 10.1464 10.8536C10.0527 10.7598 10 10.6326 10 10.5C10 10.3674 10.0527 10.2402 10.1464 10.1464C10.2402 10.0527 10.3674 10 10.5 10H12.5C12.6326 10 12.7598 10.0527 12.8536 10.1464C12.9473 10.2402 13 10.3674 13 10.5ZM9 10.5C9 10.6326 8.94732 10.7598 8.85355 10.8536C8.75979 10.9473 8.63261 11 8.5 11H7.5C7.36739 11 7.24021 10.9473 7.14645 10.8536C7.05268 10.7598 7 10.6326 7 10.5C7 10.3674 7.05268 10.2402 7.14645 10.1464C7.24021 10.0527 7.36739 10 7.5 10H8.5C8.63261 10 8.75979 10.0527 8.85355 10.1464C8.94732 10.2402 9 10.3674 9 10.5Z"
                      fill="#3749C0"/>
              </g>
            </svg>
            <p>{{ $t('poperBillings') }}</p>
          </router-link>
          <div class="profile-modal-info_item partnership" @click="openPartnershipLink">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g id="icon/24px/user">
                <path id="Vector"
                      d="M7.47365 13.6213C7.44602 13.7295 7.38225 13.8255 7.29245 13.8941C7.20266 13.9627 7.092 14 6.97807 14C6.93503 14.0002 6.89212 13.9952 6.85035 13.985L4.80672 13.4851C4.74983 13.4711 4.69582 13.4476 4.64706 13.4157L3.11434 12.4159C3.00162 12.3423 2.92339 12.2279 2.89687 12.0979C2.87034 11.9679 2.89768 11.8328 2.97289 11.7226C3.04809 11.6123 3.16499 11.5357 3.29787 11.5098C3.43075 11.4838 3.56873 11.5105 3.68145 11.5841L5.14009 12.5359L7.09814 13.0152C7.16356 13.0307 7.2252 13.0587 7.27952 13.0976C7.33384 13.1365 7.37977 13.1855 7.41466 13.2419C7.44956 13.2982 7.47273 13.3607 7.48286 13.4258C7.49298 13.4909 7.48985 13.5574 7.47365 13.6213ZM15.9477 7.59353C15.9058 7.71813 15.839 7.83336 15.7513 7.93257C15.6636 8.03178 15.5567 8.11301 15.4368 8.17156L13.9245 8.91145L10.4069 12.354C10.3445 12.415 10.2669 12.4592 10.1819 12.4822C10.0968 12.5052 10.0071 12.5062 9.92153 12.4852L5.83428 11.4854C5.77212 11.4701 5.71343 11.4436 5.66121 11.4073L2.11552 8.93019L0.56492 8.17156C0.322581 8.05303 0.138275 7.84516 0.0525273 7.59369C-0.0332206 7.34221 -0.0133901 7.06771 0.107658 6.83053L1.69466 3.72541C1.81581 3.48828 2.02824 3.30794 2.28524 3.22404C2.54224 3.14013 2.82278 3.15954 3.06517 3.27798L4.47399 3.96537L7.85875 3.01927C7.95057 2.99358 8.04792 2.99358 8.13975 3.01927L11.5245 3.96537L12.9333 3.27798C13.1757 3.15954 13.4563 3.14013 13.7133 3.22404C13.9703 3.30794 14.1827 3.48828 14.3038 3.72541L15.8908 6.83053C15.9514 6.94773 15.9876 7.0755 15.9973 7.20647C16.0071 7.33743 15.9902 7.46899 15.9477 7.59353ZM12.9985 8.40215L11.2607 5.00145H9.22862L6.46717 7.62603C7.27568 8.13157 8.54336 8.27092 9.68077 7.14923C9.7696 7.06162 9.88841 7.00925 10.0143 7.00222C10.1403 6.99518 10.2644 7.03397 10.3628 7.11111L12.5604 8.83396L12.9985 8.40215ZM1.02154 7.27733L2.15128 7.83037L3.73829 4.72525L2.60855 4.17221L1.02154 7.27733ZM11.8317 9.54197L10.062 8.15532C8.81414 9.15516 7.22969 9.28701 5.91666 8.46777C5.78751 8.38737 5.67846 8.27961 5.59757 8.15245C5.51669 8.02528 5.46604 7.88196 5.44936 7.73306C5.43269 7.58417 5.45041 7.43352 5.50123 7.29223C5.55205 7.15094 5.63466 7.02262 5.74296 6.91677C5.74449 6.91495 5.74621 6.91327 5.74807 6.91177L8.61297 4.19283L7.99989 4.02161L4.7799 4.92209L3.03196 8.34216L6.17403 10.5387L9.88705 11.4467L11.8317 9.54197ZM14.9763 7.27733L13.3912 4.17221L12.2615 4.72525L13.8485 7.83037L14.9763 7.27733Z"
                      fill="#3749C0"/>
              </g>
            </svg>
            <p>{{ $t('poperPartnership') }}</p>
          </div>
          <router-link
            :to="{ name: 'learning-center-view' }"
            class="profile-modal-info_item learning-center"
            @click="toggleProfileModal"
          >
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M2 3.33333C2 2.59695 2.59695 2 3.33333 2H12.6667C13.403 2 14 2.59695 14 3.33333V10.6667C14 11.403 13.403 12 12.6667 12H7.33333L4 14V12H3.33333C2.59695 12 2 11.403 2 10.6667V3.33333Z"
                stroke="#3749C0"
                stroke-width="1.3"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M5.33594 5.3335H10.6693M5.33594 8.00016H9.33594"
                stroke="#3749C0"
                stroke-width="1.3"
                stroke-linecap="round"
              />
            </svg>
            <p>{{ $t('learningCenterTitle') }}</p>
          </router-link>
          <div class="profile-modal-info_item idea" @click="openIdeaModal">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g clip-path="url(#clip0_7726_58160)">
                <path
                    d="M12.668 6.4135C12.668 8.1335 11.8213 9.45683 10.5333 10.3282C10.2333 10.5308 10.0833 10.6322 10.0093 10.7482C9.93597 10.8628 9.90997 11.0148 9.85997 11.3175L9.81997 11.5528C9.73197 12.0848 9.6873 12.3508 9.50063 12.5088C9.31397 12.6668 9.04463 12.6668 8.5053 12.6668H6.76397C6.22463 12.6668 5.9553 12.6668 5.76863 12.5088C5.58197 12.3508 5.53797 12.0848 5.44863 11.5528L5.40997 11.3175C5.3593 11.0155 5.33463 10.8642 5.2613 10.7495C5.18797 10.6348 5.0373 10.5322 4.73664 10.3268C3.46264 9.4555 2.66797 8.13283 2.66797 6.4135C2.66797 3.60883 4.90663 1.3335 7.66797 1.3335C8.00388 1.33314 8.33895 1.3671 8.66797 1.43483"
                    stroke="#3749C0" stroke-linecap="round" stroke-linejoin="round"/>
                <path
                    d="M9.0026 12.6668V13.3335C9.0026 13.9622 9.0026 14.2762 8.80727 14.4715C8.61194 14.6668 8.29794 14.6668 7.66927 14.6668C7.0406 14.6668 6.7266 14.6668 6.53127 14.4715C6.33594 14.2762 6.33594 13.9622 6.33594 13.3335V12.6668M11.0026 1.3335L11.1746 1.79816C11.3999 2.4075 11.5126 2.71216 11.7346 2.93416C11.9573 3.15683 12.2619 3.2695 12.8713 3.49483L13.3359 3.66683L12.8713 3.83883C12.2619 4.06416 11.9573 4.17683 11.7353 4.39883C11.5126 4.6215 11.3999 4.92616 11.1746 5.5355L11.0026 6.00016L10.8306 5.5355C10.6053 4.92616 10.4926 4.6215 10.2706 4.3995C10.0479 4.17683 9.74327 4.06416 9.13394 3.83883L8.66927 3.66683L9.13394 3.49483C9.74327 3.2695 10.0479 3.15683 10.2699 2.93483C10.4926 2.71216 10.6053 2.4075 10.8306 1.79816L11.0026 1.3335Z"
                    stroke="#3749C0" stroke-linecap="round" stroke-linejoin="round"/>
              </g>
              <defs>
                <clipPath id="clip0_7726_58160">
                  <rect width="16" height="16" fill="white"/>
                </clipPath>
              </defs>
            </svg>
            <p>{{ $t('poperIdea') }}</p>
          </div>
          <div class="profile-modal-info_item logout">
            <div class="logout_wrapper logout_half" @click.prevent="logout">
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11.3333 10.6665L14 7.99984M14 7.99984L11.3333 5.33317M14 7.99984L4.66667 7.99984M8.66667 10.6665V11.3332C8.66667 12.4377 7.77124 13.3332 6.66667 13.3332H4C2.89543 13.3332 2 12.4377 2 11.3332V4.6665C2 3.56193 2.89543 2.6665 4 2.6665H6.66667C7.77124 2.6665 8.66667 3.56193 8.66667 4.6665V5.33317"
                    stroke="#B22222" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"
                />
              </svg>
              <p>{{ $t('poperLogout') }}</p>
            </div>

            <div class="lang_half" @click.stop>
              <LanguageSelectorFlagged ref="langSelector" @change-locale="changeLocale"/>
            </div>
          </div>
          <div class="profile-modal-info_have_questions">
            <p>{{ $t('haveQuestions') }}</p>
            <a href="mailto:project@adsquiz.io"> project@adsquiz.io </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {useUserStore} from "@/store/userStore";
import {useModalsStore} from '@/store/modalsStore'
import {getCurrentTariff} from "@/utils/leadConsumption";
import usersServices from "@/services/users.service";
import {fragmentUpdateUserLang} from "@/graphql/fragments/mutation/users.fragments";
import LanguageSelectorFlagged from "@/components/common/LanguageSelectorFlagged.vue";

export default {
  components: {LanguageSelectorFlagged},
  props: {
    isAuthenticated: Boolean,
    isOpenedProfileModal: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      userStore: useUserStore(),
      modalStore: useModalsStore(),
    }
  },
  computed: {
    user() {
      return this.userStore.userData || {};
    },
    currentActiveTariff() {
      return getCurrentTariff(this.user.tarifs || []);
    },
  },
  methods: {
    toggleProfileModal() {
      this.$refs.langSelector?.closeDropdown?.();
      this.$emit('togle-profile-modal', false);
    },
    openIdeaModal() {
      return this.modalStore.openSuggestIdea();
    },
    openPartnershipLink() {
      window.open('https://adsquiz.firstpromoter.com', '_blank');
    },
    mountedLang(interfaceLang) {
      var htmlElement = document.getElementsByTagName('html')[0]
      htmlElement.setAttribute('lang', interfaceLang);
    },
    async updateUserLang(locale) {
      try {
        await usersServices.updateInterfaceLang({id: this.user.id, interface_lang: locale}, fragmentUpdateUserLang)
      } catch (error) {
        this.$notify({
          title: 'Помилка в оновлені даних: "' + this.user.email,
          type: 'error'
        });
        console.log(error);
      }
    },
    changeLocale(locale) {
      this.$i18n.locale = locale
      localStorage.setItem('locale_lang', locale)
      this.mountedLang(this.$i18n.locale)
      if (this.isAuthenticated) {
        this.updateUserLang(this.$i18n.locale)
      }
    },
  },
};
</script>
<style scoped>
.profile-modal-wrap {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: flex-end;
}

.profile-modal-info {
  background: #E2F4FF;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 16px;
  justify-content: space-between;
}

.profile-modal-info div p {
  font-size: 12px;
  line-height: 16px;
  font-weight: 400;;
}

.profile-modal-info div p:first-of-type {
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
}

.profile-plan {
  border-radius: 4px;
  padding: 4px 12px;
  background: #eff1ff;
  color: var(--color-main-blue);
  font-size: 12px;
  font-weight: 600;
  line-height: 16px;
}

.profile-modal-menu {
  background: #fff;
  margin-top: 60px;
  margin-right: 28px;
  border-radius: 8px;
  width: 300px;
  /* padding: 12px 10px; */
  display: flex;
  flex-direction: column;
  height: max-content;
  box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.16);
}

@media screen and (max-width: 480px) {
  .profile-modal-menu {
    margin-right: 10px;
  }
}

.profile-modal-menu a,
.profile-modal-menu input {
  color: var(--color-main-black);
  border: none;
}

.profile-modal-info_have_questions {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
}

.profile-modal-info_have_questions p {
  font-weight: 600;
  line-height: 16px;
  font-size: 12px;
}

.profile-modal-info_have_questions a {
  color: var(--color-main-blue);
  font-size: 12px;
  font-weight: 700;
}

.profile-modal-info_item {
  display: flex;
  flex-direction: row;
  gap: 12px;
  justify-content: flex-start;
  padding: 12px 16px;
  align-items: center;
  cursor: pointer;
  transition: background 0.3s ease;
}

.profile-modal-info_item:hover {
  background: linear-gradient(to right, #FFFFFF, #ECEFFF);
}

.profile-modal-info_item.logout {
  border-bottom: 1px solid #D9D9D9;
  padding: 0;
  gap: 0;
  cursor: default;
  align-items: stretch;
}

.profile-modal-info_item.logout:hover {
  background: none;
}

.profile-modal-info_item.logout .lang_half:hover .selected-language:hover {
  background: transparent;
}

.logout_half,
.lang_half {
  flex: 0 0 50%;
  width: 50%;
  min-width: 0;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  padding: 0;
}

.logout_half {
  padding: 12px 16px;
  gap: 12px;
  cursor: pointer;
}

.logout_half:hover {
  background: linear-gradient(to right, #FFFFFF, #ECEFFF);
}

.logout_half:hover p {
  color: #B22222;
}

.profile-modal-info_item svg path {
  transition: fill 0.3s ease;
}

.profile-modal-info_item.profile:hover svg path {
  stroke: #8D17B4;
}

.profile-modal-info_item.billings:hover svg path {
  fill: #24986c;
}

.profile-modal-info_item.partnership:hover svg path {
  fill: #ED804C;
}

.profile-modal-info_item.idea:hover svg path {
  stroke: #FD508B;
}

.profile-modal-info_item.team:hover svg path,
.profile-modal-info_item.team:hover svg circle {
  stroke: #57bff6;
}

.learning-center {
  display: none;
}
</style>
